export const FETCH_NOT_DELIVERED_REASON_LIST_REQUEST =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_LIST_REQUEST'
export const FETCH_NOT_DELIVERED_REASON_LIST_SUCCESS =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_LIST_SUCCESS'
export const FETCH_NOT_DELIVERED_REASON_LIST_FAILURE =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_LIST_FAILURE'

export const FETCH_NOT_DELIVERED_REASON_REQUEST =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_REQUEST'
export const FETCH_NOT_DELIVERED_REASON_SUCCESS =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_SUCCESS'
export const FETCH_NOT_DELIVERED_REASON_FAILURE =
  'notDeliveredReasonTypes/FETCH_NOT_DELIVERED_REASON_FAILURE'

export const DELETE_NOT_DELIVERED_REASON_REQUEST =
  'notDeliveredReasonTypes/DELETE_NOT_DELIVERED_REASON_REQUEST'
export const DELETE_NOT_DELIVERED_REASON_SUCCESS =
  'notDeliveredReasonTypes/DELETE_NOT_DELIVERED_REASON_SUCCESS'
export const DELETE_NOT_DELIVERED_REASON_FAILURE =
  'notDeliveredReasonTypes/DELETE_NOT_DELIVERED_REASON_FAILURE'

export const CREATE_NOT_DELIVERED_REASON_REQUEST =
  'notDeliveredReasonTypes/CREATE_NOT_DELIVERED_REASON_REQUEST'
export const CREATE_NOT_DELIVERED_REASON_SUCCESS =
  'notDeliveredReasonTypes/CREATE_NOT_DELIVERED_REASON_SUCCESS'
export const CREATE_NOT_DELIVERED_REASON_FAILURE =
  'notDeliveredReasonTypes/CREATE_NOT_DELIVERED_REASON_FAILURE'

export const UPDATE_NOT_DELIVERED_REASON_REQUEST =
  'notDeliveredReasonTypes/UPDATE_NOT_DELIVERED_REASON_REQUEST'
export const UPDATE_NOT_DELIVERED_REASON_SUCCESS =
  'notDeliveredReasonTypes/UPDATE_NOT_DELIVERED_REASON_SUCCESS'
export const UPDATE_NOT_DELIVERED_REASON_FAILURE =
  'notDeliveredReasonTypes/UPDATE_NOT_DELIVERED_REASON_FAILURE'

export const UPDATE_FIELD = 'notDeliveredReasonTypes/UPDATE_FIELD'
export const SET_DEFAULT_DATA = 'notDeliveredReasonTypes/SET_DEFAULT_DATA'
